import styled, {css} from "styled-components";

const dragFocused = css`
    border-color: #5590c8;
`;

const dragActive = css`
    border-color: #5590c8;
`;

const dragReject = css`
    border-color: #e57878;
`;

const dragAccept = css`
    border-color: #78e5d5;
`;

export const DropContainer = styled.div.attrs({
    className:"dropzone"
})`
    min-width: 82px;
    min-height: 150px;
    border: 2px dashed #ddd;
    border-radius: 4px;
    cursor: pointer;
    background-color: #fbfbfb;
    color: #5590c8;
    transition: height 0.2s ease;
    
    ${props => props.isActive && dragActive};
    ${props => props.isFocused && dragFocused};
    ${props => props.isDragReject && dragReject};
    ${props => props.isDragAccept && dragAccept};
`;

const messageColors = {
    default: '#585858',
    error: '#e57878',
    success: '#78e5d5'
}

export const UploadMessage = styled.p`
    display:flex;
    color: ${props => messageColors[props.type || 'default']};
    justify-content: center;
    align-items: center;
    font-weight: 500;
    margin: 0 20px 10px;
    text-align: center;
`;

export const IconColor = styled.div `
    text-align: center;
    font-size: 2.8em;
    margin-top: 20px; 
    color: ${props => messageColors[props.type || 'default']};
`
